import { NavLink } from 'react-router-dom';
import { useAdminAuth } from '../../hooks/useAdminAuth';
import { useState } from 'react';

const AdminPageLogin = () => {
   const [email, setEmail] = useState('');
   const [password, setPassword] = useState('');
   const { loginAdmin } = useAdminAuth();

   const handleSubmit = (e) => {
      e.preventDefault();
      loginAdmin(email, password);
   };

   return (
      <div className="ppt_admin_content">
         <nav className="navbar navbar-expand-lg p-0 mb-4 mb-lg-5">
            <div className="container-fluid max py-4">
               <div className="col-auto">
                  <NavLink to="/" className="">
                     <img src={process.env.PUBLIC_URL + '/assets/img/lm_logo_propert.svg'} alt="ProperT" border="0" />
                  </NavLink>
               </div>
            </div>
         </nav>
         <div className="container-fluid max">
            <div className="row align-items-center justify-content-center" style={{ minHeight: '70vh' }}>
               <div className="col-12 col-md-6 col-lg-4">
                  <form className="ppt_form signIn" onSubmit={handleSubmit}>
                     <h3 className="ppt_form_title mb-5">Admin Sign In</h3>
                     <div className="ppt_input_style mb-4">
                        <label>Email</label>
                        <div>
                           <input
                              className="form-control"
                              type="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                           />
                        </div>
                     </div>
                     <div className="ppt_input_style mb-4">
                        <label>Password</label>
                        <div>
                           <input
                              className="form-control"
                              type="password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              required
                           />
                        </div>
                     </div>
                     <div className="ppt_input_style mb-3 mb-lg-5">
                        <button type="submit" className="ppt_btn_primary">Sign In</button>
                     </div>
                  </form>
               </div>
            </div>
         </div>
      </div>
   );
};
export default AdminPageLogin;